<template>
  <div ref="quantidadePagantesDiaChart" @update-charts="update" />
</template>

<script>
import ApexCharts from 'apexcharts';
import { i18n } from '@/modules/localization/index.js';
import eventbus from '@/modules/core/services/eventbus';
import estatisticasChartsDefaultOptions from './estatisticasChartsDefaultOptions';
import { roundTo } from '@/modules/core/utils/formats';
export default {
  props: {
    loading: { type: Boolean, required: true },
  },
  data: () => ({
    quantidadePagantesDiaChart: null,
    options: estatisticasChartsDefaultOptions,
  }),
  mounted() {
    this.quantidadePagantesDiaChart = new ApexCharts(this.$refs.quantidadePagantesDiaChart, this.options);
    this.quantidadePagantesDiaChart.render();
    eventbus.on('update-charts', this.update);
  },
  unmounted() {
    this.quantidadePagantesDiaChart.destroy();
    eventbus.off('update-charts', this.update);
  },
  methods: {
    async update(chartsData) {
      const x = chartsData.quantidadePagantesDia.map((x) => x.dia);
      const y = chartsData.quantidadePagantesDia.map((x) => x.quantidade);
      this.quantidadePagantesDiaChart.updateOptions({
        chart: {
          type: 'bar',
        },
        plotOptions: {
          bar: {
            borderRadius: 2,
            horizontal: false,
          },
        },
        title: {
          text: i18n.global.t('quantidadePagantesDia'),
        },
        subtitle: {
          text: i18n.global.t('media') + roundTo(chartsData.mediaPagantesDia, 2),
        },
        series: [{ data: y }],
        xaxis: { categories: x },
      });
    },
  },
};
</script>
